<template>
  <div :class="$style.header">
    <div :class="$style.headerContainer">
      <div :class="$style.headerLogo">
        <img src="@/assets/img/horizontal.png"
             alt="Burger Boss">
      </div>
      <div :class="$style.headerLogoMobile">
        <img src="@/assets/img/white.png"
             alt="Burger Boss">
      </div>
      <div v-if="user"
           :class="$style.headerUserData">
        <DesktopUserData />
      </div>

      <div v-else
           :class="$style.guestTitle">GuestCheckout</div>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import DesktopUserData from './DesktopUserData';

  /**
   * Renders header component for desktop layout.
   */
  @Component({
    name:       'DesktopHeader',
    components: {
      DesktopUserData,
    },
  })
export default class DesktopHeader extends Vue {
    user = {
      name: 'John Doe',
    };
  }
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";
  .header {
    padding: 15px 0;
    background-color: $title-black;
    display: flex;
    align-items: center;
    height: 70px;
    .headerContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-left: 16px;
      padding-right: 23px;
    }
  }
  .headerLogo {
    display: flex;
    position: absolute;
    top: 15px;
    left: 16px;
    max-width: 225px;
  }
  .headerLogoMobile {
    position: absolute;
    top: 15px;
    left: 16px;
    display: none;
    img {
      max-width: 100%;
      height: auto;
    }
  }

  .guestTitle {
    color: $white;
    font-family: 'Gotham', sans-serif;
    font-weight: 700;
    font-size: 20px;
    text-transform: uppercase;
  }

  .headerUserData {
    position: absolute;
    right: 0;
  }
  @media screen and (max-width: 530px) {
    .header {
      padding: 8px 0;

      .headerContainer {
        padding-right: 16px;
      }
    }

    .headerLogo {
      display: none;
    }

    .headerLogoMobile {
      display: block;
      max-width: 48px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopCheckoutHeader.vue